import { render, staticRenderFns } from "./rejection-form.vue?vue&type=template&id=766c17c6&"
import script from "./rejection-form.vue?vue&type=script&lang=js&"
export * from "./rejection-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports